export const QUERYSTRING_IFRAMEURL = 'iframeUrl';
